
export default function Process() {
  const steps = [
    { name: '相談', duration: '' },
    { name: '診断', duration: '1週間' },
    { name: '設計', duration: '' },
    { name: '構築', duration: '2〜4週間' },
    { name: 'テスト', duration: '' },
    { name: '運用', duration: '' }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900">
            導入までの<strong className="text-primary">流れ</strong>
          </h2>
        </div>
        
        <div className="flex items-start justify-center gap-2 md:gap-4 flex-wrap">
          {steps.map((step, index) => (
            <div key={index} className="flex items-start">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 md:w-20 md:h-20 bg-primary text-white rounded-full flex items-center justify-center text-lg md:text-2xl font-black shadow-lg">
                  {index + 1}
                </div>
                <div className="mt-2 md:mt-4 text-center min-h-[40px] md:min-h-[60px]">
                  <div className="text-sm md:text-lg font-bold text-gray-900">{step.name}</div>
                  {step.duration && (
                    <div className="text-xs md:text-sm text-gray-600 mt-0.5 md:mt-1">{step.duration}</div>
                  )}
                </div>
              </div>
              
              {index < steps.length - 1 && (
                <div className="w-4 md:w-12 h-0.5 bg-primary mx-1 md:mx-2 mt-6 md:mt-10 flex-shrink-0"></div>
              )}
            </div>
          ))}
        </div>
        
        <div className="text-center mt-8 md:mt-12">
          <p className="text-xs md:text-sm text-gray-600">
            ※構築期間は案件により2〜4週間程度変動します
          </p>
        </div>
      </div>
    </section>
  );
}
